import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

@Component({
  selector: 'app-certificates',
  templateUrl: './certificates.component.html',
  styleUrls: ['./certificates.component.css'],
})
export class CertificatesComponent implements OnInit {
  certificate: any = '<p></p>';
  constructor(private modelService: NgbModal, public sanitizer: DomSanitizer) {}
  userForm!: FormGroup;
  getCourseArray: any = [
    {
      key: 'Christianity 101',
      value: 'Christianity 101',
      course: 'Discipleship',
    },
    {
      key: 'Christianity 101 Youth Edition',
      value: 'Christianity 101 Youth Edition',
      course: 'Discipleship',
    },
    {
      key: 'A Panorama of the Bible',
      value: 'A Panorama of the Bible',
      course: 'Discipleship',
    },
    {
      key: 'Learning to Serve: Jesus as Role Model',
      value: 'Learning to Serve: Jesus as Role Model',
      course: 'Discipleship',
    },
    {
      key: 'Welcome to Your Ministry',
      value: 'Welcome to Your Ministry',
      course: 'Church Ministry',
    },
    {
      key: 'How to Discover Your Spiritual Gifts',
      value: 'How to Discover Your Spiritual Gifts',
      course: 'Church Ministry',
    },
    {
      key: 'Your Ministry of Prayer',
      value: 'Your Ministry of Prayer',
      course: 'Church Ministry',
    },
    {
      key: 'Outreach as a Life-style',
      value: 'Outreach as a Life-style',
      course: 'Church Ministry',
    },
    {
      key: 'Your Ministry at Home',
      value: 'Your Ministry at Home',
      course: 'Church Ministry',
    },
    {
      key: 'Touching Tomorrow by Teaching Children',
      value: 'Touching Tomorrow by Teaching Children',
      course: 'Church Ministry',
    },
    {
      key: 'Christianity in the Workplace',
      value: 'Christianity in the Workplace',
      course: 'Church Ministry',
    },
    {
      key: 'Equipping for Leadership',
      value: 'Equipping for Leadership',
      course: 'Church Leadership',
    },
    {
      key: 'Truth That Transforms',
      value: 'Truth That Transforms',
      course: 'Church Leadership',
    },
    {
      key: 'A Survey of the New Testament',
      value: 'A Survey of the New Testament',
      course: 'BibleTeaching',
    },
    {
      key: 'A Survey of the Old Testament',
      value: 'A Survey of the Old Testament',
      course: 'BibleTeaching',
    },
    {
      key: 'How to Study the Bible',
      value: 'How to Study the Bible',
      course: 'BibleTeaching',
    },
    {
      key: 'Preparing to Preach',
      value: 'Preparing to Preach',
      course: 'Pastoral Ministry Track',
    },
    {
      key: 'A Panorama of Christian History',
      value: 'A Panorama of Christian History',
      course: 'Pastoral Ministry Track',
    },
    {
      key: 'Contending for the Faith',
      value: 'Contending for the Faith',
      course: 'Pastoral Ministry Track',
    },
  ];
  getDiplomaCourse: any = [
    {
      key: 'Discipleship',
      value: 'Discipleship',
      course: 'Discipleship',
    },
    {
      key: 'Church Ministry',
      value: 'Church Ministry',
      course: 'Church Ministry',
    },
    {
      key: 'Church Leadership',
      value: 'Church Leadership',
      course: 'Church Leadership',
    },
    {
      key: 'Bible Teaching',
      value: 'Bible Teaching',
      course: 'Bible Teaching',
    },
    {
      key: ' Pastoral Ministry',
      value: ' Pastoral Ministry',
      course: ' Pastoral Ministry',
    },
  ];

  ngOnInit(): void {
    this.userForm = new FormGroup({
      firstname: new FormControl('', [Validators.required]),
      lastname: new FormControl('', [Validators.required]),
      course: new FormControl('', [Validators.required]),
    });
  }

  DownloadDiplomaCertificate() {
    if (this.userForm.valid) {
      let data = document.getElementById('contentToConvert1');
      html2canvas(data as any).then((canvas) => {
        var imgWidth = 210;
        var pageHeight = 295;
        var imgHeight = (canvas.height * imgWidth) / canvas.width;
        var heightLeft = imgHeight;
        const contentDataURL = canvas.toDataURL('image/png');
        let pdfData = new jsPDF('l', 'mm', 'a4');
        var position = 0;
        pdfData.addImage(contentDataURL, 'PNG', 0, position, 297, 210);
        pdfData.save(`MyDiplomaCertificatePdf.pdf`);
        this.closeModel();
      });
    } else {
      this.userForm.markAllAsTouched();
    }
  }
  DownloadCertificate() {
    if (this.userForm.valid) {
      let data = document.getElementById('contentToConvert');
      html2canvas(data as any).then((canvas) => {
        var imgWidth = 210;
        var pageHeight = 295;
        var imgHeight = (canvas.height * imgWidth) / canvas.width;
        var heightLeft = imgHeight;
        const contentDataURL = canvas.toDataURL('image/png');

        let pdfData = new jsPDF('l', 'mm', 'a4');
        var position = 0;
        pdfData.addImage(contentDataURL, 'PNG', 0, position, 297, 210);

        pdfData.save(`MyCertificatePdf.pdf`);
        this.closeModel();
      });
    } else {
      this.userForm.markAllAsTouched();
    }
  }

  PrintCertificate() {
    if (this.userForm.valid) {
      var printContents = document.getElementById('contentToConvert').innerHTML;
      var originalContents = document.body.innerHTML;
      // document.body.innerHTML = printContents;
      // window.print();
      // document.body.innerHTML = originalContents;
    } else {
      this.userForm.markAllAsTouched();
    }
  }

  closeModel() {
    this.userForm.reset();
    this.modelService.dismissAll();
  }

  isControlValid(controlName: string): boolean {
    const control = this.userForm.controls[controlName];
    return control.valid && (control.dirty || control.touched);
  }

  isControlInvalid(controlName: string): boolean {
    const control = this.userForm.controls[controlName];
    return control.invalid && (control.dirty || control.touched);
  }

  controlHasError(validation: any, controlName: string | number): boolean {
    const control = this.userForm.controls[controlName];
    return control.hasError(validation) && (control.dirty || control.touched);
  }

  isControlTouched(controlName: string | number): boolean {
    const control = this.userForm.controls[controlName];
    return control.dirty || control.touched;
  }

  getCourseNameByKey(key: string) {
    return this.getCourseArray.find((s) => s.key === key)?.course || '';
  }
}
